import { Link } from '~/components/link';
import { useFolderPath } from '~/contexts';

export const StudioLocation = ({ designFolderId }: { designFolderId: number }) => {
  const path = useFolderPath(designFolderId);
  const joinedPath = path
    .slice(1)
    .map((x) => x.name)
    .join('/');

  return (
    <Link onClick={(e) => e.stopPropagation()} to={`../${designFolderId}`}>
      /{joinedPath}
    </Link>
  );
};
